var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { missionPositionsForShiftFetchKey } from '../../../../ui/features/shift-details/hooks/useMissionPositionsForShift';
import { useShiftParticipantStorage } from '../../../../ui/hooks';
import { defaultFetcherOptions } from '../../../../ui/utils/defaultFetcherOptions';
import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import React from 'react';
import useSWR from 'swr';
export const useAccountParticipationIds = (userId) => {
    var _a;
    const participantStorage = useShiftParticipantStorage();
    const fetchUserParticipations = (userId) => __awaiter(void 0, void 0, void 0, function* () {
        return yield participantStorage.list({
            filter: [
                {
                    column: 'participantId',
                    op: '=',
                    value: userId,
                },
            ],
        });
    });
    const { data, mutate, isLoading, error } = useSWR([missionPositionsForShiftFetchKey, userId], ([, paramsUserId]) => {
        return fetchUserParticipations(paramsUserId).catch(handleErrorSnackbar);
    }, defaultFetcherOptions);
    const accountParticipationIds = (_a = data === null || data === void 0 ? void 0 : data.rows.map((participation) => participation.id)) !== null && _a !== void 0 ? _a : [];
    const refetch = React.useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        yield mutate();
    }), [mutate]);
    return {
        refetch,
        data: accountParticipationIds,
        error,
        isLoading,
    };
};
